export const META_PIXEL_ID = '1373327467994230'

// Injects the official Meta (Facebook) Pixel base code once and fires PageView.
export function initMetaPixel() {
  if (typeof window === 'undefined') return
  const w = window as any
  if (w.fbq) {
    // Already initialized — just track a PageView.
    w.fbq('track', 'PageView')
    return
  }

  /* eslint-disable */
  // Build the fbq stub queue (official Meta Pixel base code).
  const n: any = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject the loader script safely. The original Meta snippet inserts before
  // the first <script> tag, but in some sandboxed/iframe environments no
  // <script> element exists yet, which throws on `s.parentNode`. Append to
  // <head> (with a fallback) instead.
  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const parent =
    document.head ||
    document.getElementsByTagName('head')[0] ||
    document.body ||
    document.documentElement
  if (parent) parent.appendChild(t)
  /* eslint-enable */

  w.fbq('init', META_PIXEL_ID)
  w.fbq('track', 'PageView')
}

// Helper to track standard/custom events from anywhere (e.g. checkout clicks).
export function trackMetaPixel(event: string, data?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  const w = window as any
  if (w.fbq) w.fbq('track', event, data)
}
